// To Test's registration (docs/features/tester-panel.md): the window `totest` (the dev Mac's), Home's More › To
// Test — shown only while a Mac running the dev Mac app is connected — and the wire kind `tester` (get · sync →
// channel {testing, items, ledger} · saved · error).
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { registerWire } from '../../core/wire.js'

registerWindow('totest', { module: () => import('./totest.js'), css: 'windows/totest/totest.css', key: (a, key) => 'totest-' + (key || 'mac'), title: () => 'To Test', place: ['home', 'trailing'] })
// To Test belongs to the Mac running the dev Mac app (the one results go to)
registerHomeItem({ id: 'totest', label: 'To Test', symbol: 'lucide:list-checks', needs: 'testing', section: 'more', order: 200, open: (app) => {
  const dev = app.macs.list.find((m) => m.link === 'online' && m.windows?.tester?.testing)
  if (dev) app.openWindow('totest', null, dev.key)
} })
registerWire('tester', (link, payload, m) => {
  // a push after a change carries no items: keep the ones this browser was served
  if (m?.what === 'channel') { link.tester = { ...m, items: m.items || link.tester?.items || null }; link.onTester?.(link.tester) }
})
